import React from "react";
import "./Footer.css";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import Icon from "@mui/material/Icon";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="footerContainer">
      <div className="footerContent">
        <div className="footerColumn">
          <h3>{t("footer.contactHeading")}</h3>
          <p>
            Email:{" "}
            <a href="mailto:frank.heliotis@gmail.com">
              frank.heliotis@gmail.com
            </a>
          </p>
          <p>
            Phone: <a href="tel:+306944575096">+30 6944575096</a>
          </p>
          <a href="https://wa.me/306944575096" target="_blank" rel="noreferrer">
            <Icon component={WhatsAppIcon} />
          </a>

          <img
            src="/images/viber.svg"
            alt="Viber logo"
            style={{ marginLeft: "1vw" }}
          />
          <a href="https://maps.app.goo.gl/H4vYEnN3uJVJu5DZ6" target="_blank" rel="noreferrer">
            <p>
              {t("footer.location")}: <span>Sevasti, Pieria</span>
            </p>
          </a>
        </div>

        <div className="footerColumn">
          <h3>{t("footer.linksHeading")}</h3>
          <p>
            <a href="about">{t("nav.about")}</a>
          </p>
          <p>
            <a href="contact">{t("nav.contact")}</a>
          </p>
          <p>
            <a href="terms">Terms</a>
          </p>
        </div>

        <div className="footerColumn">
          <div className="logoFooter">
            <img src={process.env.PUBLIC_URL + "/logositeurl.png"} alt="Logo" />
          </div>
        </div>
      </div>

      <div className="footerBottom">
        <p>
          &copy; {new Date().getFullYear()} {t("footer.copyright")}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
